<template>
  <transition name="slide-up">
    <LockScreen v-if="isLock && isMouted && $route.name !== 'login'" />
  </transition>
</template>

<script setup lang="ts">
import { ref, computed, onMounted, onUnmounted } from 'vue';
import { useRoute } from 'vue-router';
import { useLockscreenStore } from '@/store';

const lockscreenStore = useLockscreenStore();

const route = useRoute();
const isLock = computed(() => lockscreenStore.isLock);
const lockTime = computed(() => lockscreenStore.lockTime);
const isMouted = ref(false);

let timer: NodeJS.Timeout;
// 锁屏倒计时开始
const timekeeping = () => {
  clearInterval(timer);
  if (route.name === 'login' || isLock.value) return;
  // 设置不锁屏
  lockscreenStore.setLock(false);
  // 重置锁屏时间
  lockscreenStore.setLockTime();
  timer = setInterval(() => {
    // 锁屏倒计时递减
    lockscreenStore.setLockTime(lockTime.value - 1);
    if (lockTime.value <= 0) {
      // 设置锁屏
      lockscreenStore.setLock(true);
      return clearInterval(timer);
    }
    return true;
  }, 1000);
};

// 初始加载
onMounted(() => {
  timekeeping();
  document.addEventListener('mousedown', timekeeping);
  setTimeout(() => {
    isMouted.value = true;
  });
});
onUnmounted(() => document.removeEventListener('mousedown', timekeeping));
</script>

<style scoped>
.lock {
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  background-color: skyblue;
  height: 100vh;
  z-index: 999;
}
.slide-up-enter-active {
  animation: slide-up 0.5s;
}

.slide-up-leave-active {
  animation: slide-up 0.5s reverse;
}
@keyframes slide-up {
  0% {
    transform: translateY(-100%);
  }

  100% {
    transform: translateY(0);
  }
}
</style>
